import HarveyPortrait from "./img/authors/harvey.png";
import IlsePortrait from "./img/authors/ilse.jpg";
import LuukPortrait from "./img/authors/luuk.jpg";
import MaartenPortrait from "./img/authors/maarten.jpg";
import RobinPortrait from "./img/authors/robin.jpg";

/**
 * Bylines for the five real writers in the knowledge base's `website/authors.md`.
 *
 * Name, region and blurb arrive on the article — the knowledge base resolves them so every
 * surface shows the same byline. The portrait cannot: it is a binary that has to be bundled,
 * and the KB has no route into this repo. So the document carries the author's `slug` and this
 * maps it to the image.
 *
 * Real colleagues, deliberately. `authors.md` records a fictional persona as an E-E-A-T and
 * scaled-content-abuse risk and makes it a hard rule, which is why the four invented names that
 * used to rotate across the blog cards are gone.
 */
const AUTHOR_AVATARS: Record<string, string> = {
	ilse: IlsePortrait,
	robin: RobinPortrait,
	maarten: MaartenPortrait,
	luuk: LuukPortrait,
	harvey: HarveyPortrait,
};

export interface Byline {
	name: string;
	role: string;
	avatar: string;
	blurb: string;
}

/** The house byline, for an article with no region owner. `authors.md` specifies these words. */
export const HOUSE_AUTHOR: Byline = {
	name: "The Stippl editors",
	role: "Stippl editorial",
	avatar: "",
	blurb: "Written by the Stippl editors and checked against the trips our travellers actually plan.",
};

/** An article's byline with its portrait attached, or the house one. */
export function bylineOf(author?: { slug?: string; name?: string; role?: string; blurb?: string } | null): Byline {
	if (!author?.name) return HOUSE_AUTHOR;
	return { ...HOUSE_AUTHOR, ...author, avatar: AUTHOR_AVATARS[author.slug || ""] || "" };
}
